import React, { Component } from 'react';
import { Link } from 'react-router-dom';

import TextLogo from '../logo/textLogo';
import BlueLogoIcon from '../logo/blueLogoIcon';
import './header.css';

class Header extends Component {
  render() {
    return (
      <div className="Header">
        <div className="Start">
          <Link to={'/'}>
            <BlueLogoIcon />
          </Link>
        </div>
        <div className="Middle">
          <Link to={'/'}>
            <TextLogo />
          </Link>
        </div>
        <div className="Right" />
      </div>
    );
  }
}

export default Header;



// WEBPACK FOOTER //
// ./src/components/header/index.js